// One shared buy state per page, driven by a connector. Every buy UI on the
// page renders from it, so two of them can never disagree about the cart.
import { buyReducer, initialBuyState } from "./buy-state.js";
import { createListeners } from "./connector.js";

export function createShop(connector, { quantity = 1 } = {}) {
  let state = initialBuyState;
  const listeners = createListeners();
  const dispatch = (event) => {
    state = buyReducer(state, event);
    listeners.emit(state);
  };
  connector.onCartChange((cart) => dispatch({ type: "cart", cart }));

  return {
    get state() {
      return state;
    },
    /** fn(state) now and on every change; returns unsubscribe */
    subscribe(fn) {
      fn(state);
      return listeners.add(fn);
    },
    async load() {
      dispatch({ type: "load" });
      try {
        dispatch({ type: "loaded", product: await connector.getProduct() });
      } catch (error) {
        dispatch({ type: "loadFailed", error });
        console.error(error);
      }
    },
    async add() {
      dispatch({ type: "add" });
      try {
        dispatch({ type: "added", cart: await connector.addToCart(quantity) });
      } catch (error) {
        dispatch({ type: "addFailed", error });
        console.error(error);
      }
    },
    buyNow() {
      connector.buyNow(quantity);
    },
    quantity,
  };
}
